import { useState, createContext } from 'react';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import {
  EngineCorrectionReportType,
  EngineCorrectionReportDataType,
} from '@/api/entities/engineCorrection';
import { ElementType } from '@/entities/ia';
import { TResultImageCoordinatesSchema } from '@/schemas/vehicule-check-result/result-image-coordinates.schema';

type EngineCorrectionContextType = {
  reportData: EngineCorrectionReportType;
  setReportData: Dispatch<SetStateAction<EngineCorrectionReportType>>;
  listElement: ElementType[];
  setListElement: Dispatch<SetStateAction<ElementType[]>>;
  listDamage: ElementType[];
  setListDamage: Dispatch<SetStateAction<ElementType[]>>;
  dataAnnotation: TResultImageCoordinatesSchema[];
  setDataAnnotation: Dispatch<SetStateAction<TResultImageCoordinatesSchema[]>>;
  dataAnnotationDamage: TResultImageCoordinatesSchema[];
  setDataAnnotationDamage: Dispatch<
    SetStateAction<TResultImageCoordinatesSchema[]>
  >;
  currentElement: object;
  setCurrentElement: Dispatch<SetStateAction<object>>;
  currentElCanvas: object;
  setCurrentElCanvas: Dispatch<SetStateAction<object>>;
  isDeleted: boolean;
  setIsdDeleted: Dispatch<SetStateAction<boolean>>;
  sendLogs: boolean;
  setSendLogs: Dispatch<SetStateAction<boolean>>;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  reportEngineData: EngineCorrectionReportDataType;
  setReportEngineData: Dispatch<SetStateAction<EngineCorrectionReportDataType>>;
};

type EngineCorrectionProviderType = {
  children: ReactNode;
};

export const EngineCorrectionContext =
  createContext<EngineCorrectionContextType | null>(null);

const EngineCorrectionProvider = ({
  children,
}: EngineCorrectionProviderType) => {
  const [reportData, setReportData] = useState<EngineCorrectionReportType>();
  const [listElement, setListElement] = useState<ElementType[]>([]);
  const [listDamage, setListDamage] = useState<ElementType[]>([]);
  const [dataAnnotation, setDataAnnotation] = useState<
    TResultImageCoordinatesSchema[]
  >([]);
  const [dataAnnotationDamage, setDataAnnotationDamage] = useState<
    TResultImageCoordinatesSchema[]
  >([]);
  const [currentElement, setCurrentElement] = useState<object>({});
  const [currentElCanvas, setCurrentElCanvas] = useState<object>({});
  const [isDeleted, setIsdDeleted] = useState<boolean>(false);
  const [sendLogs, setSendLogs] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [reportEngineData, setReportEngineData] =
    useState<EngineCorrectionReportDataType>();

  return (
    <EngineCorrectionContext.Provider
      value={{
        reportData,
        setReportData,
        listElement,
        setListElement,
        listDamage,
        setListDamage,
        dataAnnotation,
        setDataAnnotation,
        dataAnnotationDamage,
        setDataAnnotationDamage,
        currentElement,
        setCurrentElement,
        currentElCanvas,
        setCurrentElCanvas,
        isDeleted,
        setIsdDeleted,
        sendLogs,
        setSendLogs,
        currentPage,
        setCurrentPage,
        reportEngineData,
        setReportEngineData,
      }}
    >
      {children}
    </EngineCorrectionContext.Provider>
  );
};

export default EngineCorrectionProvider;
